import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {Company} from 'main/stores/users';

class GoogleCredentials extends DomainObject {
  domain;
  company;

  _relations = {
    company: Company
  };

  constructor(other) {
    super();

    makeObservable(this, {
      domain: observable,
      company: observable
    });

    this.merge(other);
  }
}

export default GoogleCredentials;
